import type {
  ContractType,
  SilaeMemberSchema,
  SilaeMetaStatusCount,
  SilaeSynchronizationStatus,
  UpdateSilaeSyncPayload
} from '@libs/data-access/entities'
import {
  type PaginatedQueryRequest,
  type PaginatedQueryResponse,
  type QueryFnParams,
  httpServices
} from '@libs/data-access/queries'

export type FetchSilaeSynchronizedMembersOptions = QueryFnParams<{
  queryParams: PaginatedQueryRequest & {
    contract_types?: (ContractType | 'none')[]
    contract_location_id?: number
    contract_team_id?: number
    search?: string
    sort?: string
    order?: 'desc' | 'asc'
    status?: SilaeSynchronizationStatus
    only_in_progress_or_future_contracts?: boolean
  }
}>

export const fetchSilaeSynchronizedMembers = async (
  opts?: FetchSilaeSynchronizedMembersOptions
) => {
  const response = await httpServices.core.get<
    PaginatedQueryResponse<
      SilaeMemberSchema,
      'memberships',
      { status_count: SilaeMetaStatusCount }
    >
  >('/employee_management/silae/memberships', {
    params: opts?.queryParams
  })
  return response.data
}

export type UpdateSilaeSyncPayloadOptions = QueryFnParams<{
  payload: UpdateSilaeSyncPayload
}>

export const updateSilaeSync = async (opts?: UpdateSilaeSyncPayloadOptions) => {
  const response = await httpServices.core.put(
    '/employee_management/silae/memberships/bulk_sync',
    opts?.payload
  )
  return response.data
}
